import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-full-calendar-options',
	templateUrl:'./FullCalendarOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./FullCalendarOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FullCalendarOptionsPluginCompPage
{
	mdContent_966 = `\`\`\`java
import com.jwebmp.plugins.fullcalendar.options.FullCalendarOptions;
\`\`\``;
	mdContent_967 = `\`\`\`java
FullCalendarOptions()
\`\`\``;
	mdContent_968 = `\`\`\`java
new FullCalendarOptions()
    .setInitialView("timeGridWeek")
    .setSlotDuration(new FullCalendarTimeSlot(0, 15, 0))
    .setSlotMinTime(new FullCalendarTimeSlot(8, 0, 0))
    .setSlotMaxTime(new FullCalendarTimeSlot(20, 0, 0))
    .setNowIndicator(true)
    .setWeekends(false)
    .setEditable(true)
    .setSelectable(true);
\`\`\``;
	mdContent_969 = `\`\`\`java
new FullCalendarOptions()
    .setInitialView("resourceTimelineDay")
    .setSchedulerLicenseKey("your-key")
    .setResourceAreaWidth("25%")
    .setResourceAreaHeaderContent("Rooms")
    .setResourceOrder("title");
\`\`\``;
}
